import { ProductTotalCalculationStrategy } from "./product-total-strategy";
import { IProductCalculationContext } from "../models/product-calculation-context.model";

export class ProductTotalCalculator {
    private strategy: ProductTotalCalculationStrategy;

    constructor(strategy: ProductTotalCalculationStrategy) {
        this.strategy = strategy;
    }

    setStrategy(strategy: ProductTotalCalculationStrategy) {
        this.strategy = strategy;
    }

    calculateTotal(context: IProductCalculationContext) {
        this.strategy.calculateTotal(context);
    }
}
